import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { usePaywallCheckoutAttemptsContext } from "@/react/components/Paywalls/Checkout/Attempts/PaywallCheckoutAttemptsContext";

import { OFFER_PAGE_LOCALE_ROOT } from "../constants";
import { useOfferPageContext } from "../OfferPageProvider";

export const useConfirmAndDeclineButton = () => {
  const { clearErrors, getValues, setError } = useFormContext();
  const {
    refuseOfferMutation,
    previewMutation,
    couponPreviewMutation,
    isPreviewing,
  } = useOfferPageContext();
  const { submitAttempt, isProcessingAttempt } =
    usePaywallCheckoutAttemptsContext();

  const shouldBlockButtons =
    refuseOfferMutation.isPending ||
    refuseOfferMutation.isSuccess ||
    isProcessingAttempt ||
    previewMutation.isPending ||
    couponPreviewMutation.isPending;

  const handleConfirm = () => {
    clearErrors();

    if (isPreviewing) {
      return;
    }

    if (previewMutation.isSuccess) {
      const couponCode = previewMutation.data.paywall_coupon_code;
      const formData = {
        ...getValues(),
        coupon_code: couponCode,
      };
      void submitAttempt(formData);
    } else {
      setError("root", {
        message: t([OFFER_PAGE_LOCALE_ROOT, "preview_is_not_ready"]),
      });
    }
  };

  const handleDecline = () => {
    if (isPreviewing) {
      return;
    }

    refuseOfferMutation.mutate();
  };

  return {
    isProcessingAttempt,
    isProcessingRefusal: refuseOfferMutation.isPending,
    shouldBlockButtons,
    handleConfirm,
    handleDecline,
  };
};
